package com.neurobs.ccabserver.translation.components.phrasetranslation

import com.neurobs.react.ReactUtil
import com.neurobs.react.semanticui.UiGridFactory
import com.neurobs.ccabserver.translation.components.phrasetranslation.components.{BackTranslation, EngineTranslation, UserTranslation}
import com.neurobs.ccabserver.translation.states.{EngineSelectionStateGenerator, EngineTranslationStateGenerator, EngineTranslationStateProvider, PhraseSelectionStateGenerator}
import com.neurobs.ccabserver.translation.util.PhraseTranslationManager
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object PhraseTranslation {

  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val engineSelectionState = EngineSelectionStateGenerator.accessState
    val phraseSelectionState = PhraseSelectionStateGenerator.accessState

    def isSelectedEngine(engineIdentifier: String) = engineSelectionState.isSelected(engineIdentifier)

    def selectedEngineTranslations(selectedPhrase: PhraseTranslationManager) = {
      selectedPhrase.engineTranslations.filter(keyValuePair => isSelectedEngine(keyValuePair._1)).map(_._2)
    }

    def gridStyle = Seq[(String, js.Any)](("marginTop", "0px"))

    phraseSelectionState.selectedPhrase match {
      case None => null
      case Some(selectedPhrase) =>
        props.enclosingElement(
          Seq(
            UiGridFactory.Grid(
              selectedEngineTranslations(selectedPhrase).map(
                EngineTranslationStateProvider(_)(
                  EngineTranslation(
                    enclosingElement = UiGridFactory.GridColumn(_)("eight wide center aligned")
                  )
                )
              ),
              UserTranslation(
                enclosingElement = UiGridFactory.GridColumn(_)("sixteen wide center aligned")
              ),
              BackTranslation(
                enclosingElement = UiGridFactory.GridColumn(_)("sixteen wide center aligned")
              )
            )(gridStyle)
          )
        )
    }
  }
}

